<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '@ds/lib/utils'

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <div class="relative w-full overflow-auto">
    <table :class="cn('w-full caption-bottom text-sm font-ds', props.class)">
      <slot />
    </table>
  </div>
</template>
